import type { V2CreateAdminTypePropertyInput } from '@idc-forms/schemas/api-v2/admin-type-properties'
import { useSidePanelStore } from '@/shared/store/side-panel.store'
import { useCreateTypePropertyV2Mutation } from '../hooks/use-type-property-v2-mutations'
import { TypePropertyV2Form } from './type-property-v2-form'

type TypePropertyV2CreatePanelProps = {
  onDone?: () => void
}

/** "Nuevo subtipo" contra la API v2: el mismo `TypePropertyV2Form` que la edición. */
export function TypePropertyV2CreatePanel({ onDone }: TypePropertyV2CreatePanelProps) {
  const closePanel = useSidePanelStore((s) => s.closePanel)
  const createMutation = useCreateTypePropertyV2Mutation()
  const done = onDone ?? closePanel

  const handleSubmit = (values: V2CreateAdminTypePropertyInput) => {
    createMutation.mutate(values, {
      onSuccess: () => {
        done()
      }
    })
  }

  return (
    <TypePropertyV2Form
      submitLabel="Crear subtipo"
      pending={createMutation.isPending}
      onSubmit={handleSubmit}
      onCancel={done}
    />
  )
}
